import React from "react";

export default function TranslationServiceCards({
  backgroundCol,
  cardData,
  colheading,
  heading,
  content,
  topHead,
  topHead2,
  borderB,
}) {
  return (
    <div className={`${backgroundCol ? backgroundCol : "bg-darkBlue"}`}>
      <div className="mainHead py-6 text-white  mx-auto justify-center text-center">
        {borderB ? (
          borderB
        ) : (
          <span className="border-b border-textlight w-full block"></span>
        )}
        {topHead ? (
          topHead
        ) : (
          <h3 className="text-3xl font-secondary font-bold pt-12">
            <span className="text-orange">{colheading ? colheading : ""} </span>
            {heading
              ? heading
              : "Document translation services for any industry"}
          </h3>
        )}
        {topHead2 ? (
          <h2 className="text-3xl font-secondary font-bold pt-12">
            <span className="text-orange">{colheading ? colheading : ""} </span>
            {topHead2
              ? topHead2
              : "Document translation services for any industry"}
          </h2>
        ) : null}
        {content ? (
          <p className="text-center w-6/12 justify-center mx-auto leading-relaxed pt-6">
            Tomedes has performed certified legal translation services for
            thousands of law firms, attorneys and courts worldwide. Here are
            some recent cases where our legal translators delivered superb
            results with quick turnaround at competitive rates.
          </p>
        ) : null}
      </div>
      <ul className="cardsDiv  w-[90%] mx-auto text-white text-center flex flex-wrap justify-center gap-x-10">
        {cardData
          ? cardData.map(
              ({ head, content, image, link, flagHead, flagHead2 }) => (
                <li className="cardComp w-full lg:px-8 px-4  lg:w-[30%] py-10">
                  <img src={image} alt="" className="mx-auto pb-5" />
                  {flagHead ? (
                    flagHead
                  ) : (
                    <h4>
                      <a
                        href={link}
                        className="pb-4 text-xl hover:text-orange font-secondary font-bold"
                      >
                        {head}
                      </a>
                    </h4>
                  )}
                  {flagHead2 ? (
                    <h3>
                      <a
                        href={link}
                        className="pb-4 text-xl hover:text-orange font-secondary font-bold"
                      >
                        {flagHead2}
                      </a>
                    </h3>
                  ) : null}
                  <p className="font-light font-opensans tracking-wide">
                    {content}
                  </p>
                </li>
              )
            )
          : null}
      </ul>
    </div>
  );
}
